/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { BaseController } from '../../BaseController';

class AlarmTypeViewController extends BaseController {
    /** @ngInject */
    constructor(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log,
        alarmTypeService) {
        super(configuration, notificationService, waitSpinnerService, $q, $state, $stateParams, $log);
        this.alarmTypeService = alarmTypeService;
        this.$log.debug('Controller \'AlarmTypeView\' loaded');
    }

    $onInit() {
        super.$onInit();

        this.waitSpinnerService.visible = true;
        this.formDisabled = false;

        // The updateMode flag can be used to know the context in which this controller is running: creation or update.
        let initPromise;
        if (this.$stateParams.hasOwnProperty('id')) {
            this.updateMode = true;
            this.title = 'ui.alarmtype.update';
            initPromise = this.alarmTypeService.getEntity(this.$stateParams.id);
        } else {
            this.updateMode = false;
            this.title = 'ui.alarmtype.creation';
            initPromise = this.$q.resolve();
        }

        this.handleRestServiceCall(initPromise, entity => {
            this.pristineEntity = entity;
            this.reset();
        }).finally(() => {
            this.waitSpinnerService.visible = false;
        })
    }

    save() {
        this.formDisabled = true;
        let serviceActionPromise;
        if (this.updateMode) {
            serviceActionPromise = this.alarmTypeService.updateEntity(this.alarmType);
        } else {
            serviceActionPromise = this.alarmTypeService.createEntity(this.alarmType);
        }
        this.handleRestServiceCall(serviceActionPromise, () => {
            const message = 'ui.alarmtype.' + (this.updateMode ? 'updated' : 'created');
            this.notificationService.pushMessage(message, this.configuration.NOTIFIER_LEVEL_INFO);
            if (this.updateMode) {
                this.$state.reload();
            } else {
                this.$state.go('gmao.alarm.type.list');
            }
        }).finally(() => {
            this.formDisabled = false;
        });
    }

    reset() {
        this.alarmType = angular.copy(this.pristineEntity);
    }
}

export const alarmTypeViewComponent = {
    template: require('./alarmtype-view.html'),
    controller: AlarmTypeViewController
};



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/alarm/component/AlarmTypeView.js